import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { PagosService } from 'app/services/pagos-service.service';
import { ConfirmacionesService } from 'app/services/confirmaciones.service';
import { ClientesService } from 'app/services/clientes.service';
import { UtilidadesService } from 'app/services/utilidades.service';

@Component({
  templateUrl: './pendientes.component.html'
})
export class PendientesComponent implements OnInit, OnDestroy {
  //#region 👤 Context (usuario/módulo)
  currentUser: any;
  modulo: string;
  //#endregion

  //#region 💳 Pagos pendientes de validar (Firestore, async pipe)
  pagosPendientesValidar: Observable<any>;
  pagosPendientesValidarArray: any[] = [];
  //#endregion

  //#region 📄 Confirmaciones por liquidar (Firestore, live + paginación por cursor)
  confirmaciones: any[] = [];
  pageSize = 10;

  // Cursor por página (page 0 => null)
  private pageCursors: any[] = [null];
  currentPageIndex = 0;
  loadingConfirmaciones = false;
  hasNextPage = false;

  // Mantener doc final de la página actual
  private lastDocOfCurrentPage: any = null;

  // Subscripción viva a la página actual
  private confSub: Subscription | null = null;
  //#endregion

  //#region 📨 Solicitudes PENDIENTES (MySQL/PHP, polling + paginación en cliente)
  solicitudesAll: any[] = [];
  solicitudesPage: any[] = [];
  solPageSize = 5;
  solPageIndex = 0;
  loadingSolicitudes = true;
  hasNextSolicitudes = false;
  private solicitudesSub: Subscription | null = null;
  //#endregion

  //#region ✅ Solicitudes ACEPTADAS por confirmar (MySQL/PHP, polling + paginación en cliente)
  aceptadasAll: any[] = [];
  aceptadasPage: any[] = [];
  aceptadasPageSize = 5;
  aceptadasPageIndex = 0;
  loadingAceptadas = true;
  hasNextAceptadas = false;
  private aceptadasSub: Subscription | null = null;
  //#endregion

  //#region 👥 Cache nombres de clientes
  private clientesNombreCache: { [key: string]: string } = {};
  //#endregion

  //#region 🔎 Getters UI (habilitar/deshabilitar paginadores)
  get canPrev() { return this.currentPageIndex > 0; }
  get canNext() { return this.hasNextPage; }
  //#endregion

  //#region 🚀 Lifecycle
  constructor(
    private usuariosPersonalService: UsuariosPersonalService,
    private pagosService: PagosService,
    private confirmacionesService: ConfirmacionesService,
    private servicioClientes: ClientesService,
    private router: Router,
      public util: UtilidadesService,
  ) {}

  ngOnInit() {
    this.currentUser = this.usuariosPersonalService.auth;
    this.modulo = this.router.url.split('/')[1];

    console.log(this.currentUser.uid)

    this.setupPagosPendientesValidar();
    this.cargarConfirmacionesPorLiquidar(0);   // live + primera página
    this.suscribirSolicitudesPendientes();     // MySQL stream (Pendientes)
    this.suscribirSolicitudesAceptadas();      // MySQL stream (Aceptadas)
  }

  ngOnDestroy() {
    if (this.confSub)         { this.confSub.unsubscribe();         this.confSub = null; }
    if (this.solicitudesSub)  { this.solicitudesSub.unsubscribe();  this.solicitudesSub = null; }
    if (this.aceptadasSub)    { this.aceptadasSub.unsubscribe();    this.aceptadasSub = null; }
  }
  //#endregion

  //#region 💳 Pagos: configurar stream (Firestore)
  private setupPagosPendientesValidar() {
    this.pagosPendientesValidar = this.pagosService
      .obtenerPagosPorUsuarioCreadorPendienteValidar(this.currentUser.uid)
      .snapshotChanges()
      .map(pagos => {
        this.pagosPendientesValidarArray = [];
        pagos.forEach(pago => {
          const $key = pago.payload.doc.id;
          const data = { $key, ...pago.payload.doc.data() };
          if (this.pagosPendientesValidarArray.findIndex(p => p.$key === $key) === -1) {
            this.pagosPendientesValidarArray.push(data);
          }
        });
        return this.pagosPendientesValidarArray;
      });
  }
  //#endregion

  //#region 📄 Confirmaciones por liquidar: loader + navegación
  private cargarConfirmacionesPorLiquidar(pageIndex: number) {
    if (this.loadingConfirmaciones) return;
    this.loadingConfirmaciones = true;

    // cancelar stream previo
    if (this.confSub) { this.confSub.unsubscribe(); this.confSub = null; }

    const startAfterDoc = this.pageCursors[pageIndex] || null;

    // subscripción VIVA (sin take(1)) para ver cambios (montoPagado, etc)
    this.confSub = this.confirmacionesService
      .obtenerConfirmacionesNoLiquidadasPorusuarioPage(
        this.currentUser.uid,
        //"kTuQOK2N6yY4Zb2BHzeya3jFuT52",
        this.pageSize,
        startAfterDoc
      )
      .subscribe(
        ({ items, lastDoc, hasNext }) => {
          this.confirmaciones = items || [];
          this.confirmaciones = this.confirmaciones.map(c => {
            console.log(c);
            for (var idServicio in c.servicios) {
              c.inicioDeServicio = c.servicios[idServicio].itinerario.inicioDeServicio;
            }
            return c;
          });
          console.log(this.confirmaciones);
          // mantener doc final de la página actual
          this.lastDocOfCurrentPage = lastDoc || null;
          this.hasNextPage = !!hasNext;

          // cursor para la página siguiente
          if (this.lastDocOfCurrentPage) {
            this.pageCursors[pageIndex + 1] = this.lastDocOfCurrentPage;
          } else {
            this.pageCursors[pageIndex + 1] = undefined;
          }

          this.currentPageIndex = pageIndex;
          this.loadingConfirmaciones = false;
        },
        err => {
          console.error('[UI] loadPage live error:', err);
          this.confirmaciones = [];
          this.lastDocOfCurrentPage = null;
          this.hasNextPage = false;
          this.loadingConfirmaciones = false;
        }
      );
  }

  nextPage() {
    if (!this.canNext) return;
    const nextIndex = this.currentPageIndex + 1;
    const cursor = this.pageCursors[nextIndex];
    if (!cursor) return;
    this.cargarConfirmacionesPorLiquidar(nextIndex);
  }

  prevPage() {
    if (!this.canPrev) return;
    this.cargarConfirmacionesPorLiquidar(this.currentPageIndex - 1);
  }
  //#endregion

  //#region 📨 Solicitudes PENDIENTES: stream + paginación en cliente
  private suscribirSolicitudesPendientes() {
    this.loadingSolicitudes = true;

    this.solicitudesSub = this.confirmacionesService
      .obtenerSolicitudesPendientesStream(this.currentUser.uid, 15000)
      .subscribe(
        (raw: any[]) => {
          const parsed = (raw || []).map(this.normalizeSolicitud);

          // orden por fecha_creacion DESC
          parsed.sort((a, b) =>
            new Date(b.fecha_creacion).getTime() - new Date(a.fecha_creacion).getTime()
          );

          this.solicitudesAll = parsed;
          this.ensureSolicitudesPageIndexInRange();
          this.updateSolicitudesPage();
          this.loadingSolicitudes = false;

          // precarga nombres en la página visible
          this.precargarNombresClientes(this.solicitudesPage);
        },
        err => {
          console.error('[Solicitudes] stream error:', err);
          this.solicitudesAll = [];
          this.updateSolicitudesPage();
          this.loadingSolicitudes = false;
        }
      );
  }

  private updateSolicitudesPage() {
    const start = this.solPageIndex * this.solPageSize;
    const end = start + this.solPageSize;
    this.solicitudesPage = this.solicitudesAll.slice(start, end);
    this.hasNextSolicitudes = end < this.solicitudesAll.length;
  }

  private ensureSolicitudesPageIndexInRange() {
    const total = this.solicitudesAll.length;
    const start = this.solPageIndex * this.solPageSize;
    if (total > 0 && start >= total) {
      this.solPageIndex = Math.floor((total - 1) / this.solPageSize);
    }
  }

  nextSolicitudesPage() {
    if (!this.hasNextSolicitudes) return;
    this.solPageIndex++;
    this.updateSolicitudesPage();
    this.precargarNombresClientes(this.solicitudesPage);
  }

  prevSolicitudesPage() {
    if (this.solPageIndex === 0) return;
    this.solPageIndex--;
    this.updateSolicitudesPage();
    this.precargarNombresClientes(this.solicitudesPage);
  }
  //#endregion

  //#region ✅ Solicitudes ACEPTADAS: stream + paginación en cliente
  private suscribirSolicitudesAceptadas() {
    this.loadingAceptadas = true;

    this.aceptadasSub = this.confirmacionesService
      .obtenerSolicitudesAceptadasStream(this.currentUser.uid, 15000)
      .subscribe(
        (raw: any[]) => {
          const parsed = (raw || []).map(this.normalizeSolicitud);

          // orden por fecha_creacion DESC (cámbialo a fecha_confirmacion si prefieres)
          parsed.sort((a, b) =>
            new Date(b.fecha_creacion).getTime() - new Date(a.fecha_creacion).getTime()
          );

          this.aceptadasAll = parsed;
          this.ensureAceptadasPageIndexInRange();
          this.updateAceptadasPage();
          this.loadingAceptadas = false;

          this.precargarNombresClientes(this.aceptadasPage);
        },
        err => {
          console.error('[Solicitudes Aceptadas] stream error:', err);
          this.aceptadasAll = [];
          this.updateAceptadasPage();
          this.loadingAceptadas = false;
        }
      );
  }

  private updateAceptadasPage() {
    const start = this.aceptadasPageIndex * this.aceptadasPageSize;
    const end = start + this.aceptadasPageSize;
    this.aceptadasPage = this.aceptadasAll.slice(start, end);
    this.hasNextAceptadas = end < this.aceptadasAll.length;
  }

  private ensureAceptadasPageIndexInRange() {
    const total = this.aceptadasAll.length;
    const start = this.aceptadasPageIndex * this.aceptadasPageSize;
    if (total > 0 && start >= total) {
      this.aceptadasPageIndex = Math.floor((total - 1) / this.aceptadasPageSize);
    }
  }

  nextAceptadasPage() {
    if (!this.hasNextAceptadas) return;
    this.aceptadasPageIndex++;
    this.updateAceptadasPage();
    this.precargarNombresClientes(this.aceptadasPage);
  }

  prevAceptadasPage() {
    if (this.aceptadasPageIndex === 0) return;
    this.aceptadasPageIndex--;
    this.updateAceptadasPage();
    this.precargarNombresClientes(this.aceptadasPage);
  }
  //#endregion

  //#region 🧠 Normalización + caché de nombres de clientes
  private normalizeSolicitud = (s: any) => {
    const c: any = { ...s };

    // info_cotizacion
    if (c.info_cotizacion) {
      try {
        if (typeof c.info_cotizacion === 'string') {
          c.info_cotizacion = c.info_cotizacion.replace(/[\n\r\t]+/g, ' ');
          c.info_cotizacion = JSON.parse(c.info_cotizacion);
        }
      } catch(e) { c.info_cotizacion = {}; }
    } else {
      c.info_cotizacion = {};
    }

    // info_confirmacion
    if (c.info_confirmacion) {
      try {
        if (typeof c.info_confirmacion === 'string') {
          c.info_confirmacion = JSON.parse(c.info_confirmacion);
        }
      } catch(e) { c.info_confirmacion = {}; }
    } else {
      c.info_confirmacion = {};
    }

    return c;
  };

  // Cachea nombres de cliente para no golpear Firebase en cada render
  private precargarNombresClientes(items: any[]) {
    (items || []).forEach(s => {
      const clienteKey = s.info_cotizacion && s.info_cotizacion.cliente;
      if (clienteKey && !this.clientesNombreCache[clienteKey]) {
        this.servicioClientes
          .obtenerPropiedadCliente(clienteKey, 'nombre')
          .valueChanges()
          .take(1)
          .subscribe(nombre => {
            this.clientesNombreCache[clienteKey] = (nombre as string) || '';
          });
      }
    });
  }
  //#endregion

  //#region 🔧 Utilidades UI (unidades, tiempos, trackBy)

  trackByConf = (_: number, item: any) => item.$key || item.idTrosten || _;
  trackBySolicitud = (_: number, s: any) =>
    s.id_solicitud_disponibilidad || s.key_cotizacion || s.id || _;
  //#endregion
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/pendientes/pendientes.component.ts